import React from 'react';
import { useParams } from 'react-router-dom';
import { PAGE_COMMON_TEXT } from '../lang';
import { waitingForProcessing } from '../WaitProcess';
import {
  type Conditions,
  useGetConditionMeet,
} from '../../../Assessment/graphql';
import { ConditionalCheckForm } from '../../../Assessment';
import { Loading, Alert } from '../../../../components';

export const DSRCConditionCheckForm: React.FunctionComponent = () => {
  const { applicationId } = useParams();

  const { conditionMeet, registrationDeadline, loading, error } =
    useGetConditionMeet(applicationId as string);
  if (error) {
    return (
      <Alert
        openAlert={true}
        setOpenAlert={() => {}}
        alertDetails={{
          alertContent: `Error Occurs.` + (error as Error)?.message,
          alertType: 'error',
        }}
      />
    );
  }

  const hasConditionMeet = Boolean((conditionMeet?.conditions ?? []).length);
  return (
    <>
      {loading ? (
        <Loading />
      ) : hasConditionMeet ? (
        <ConditionalCheckForm
          viewMode={true}
          conditionMeet={conditionMeet}
          registrationDeadline={registrationDeadline}
          submitConditionMeet={async (values: Conditions) => {}}
        />
      ) : (
        waitingForProcessing(PAGE_COMMON_TEXT.SIDEBAR_TEXT.CONDITION_CHECK)
      )}
    </>
  );
};
